import { useEffect, useState } from 'react';
import { MantineProvider, DirectionProvider } from '@mantine/core';
import { PersistGate } from 'redux-persist/integration/react';
import { DatesProvider } from '@mantine/dates';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import router from '@/routes/AppRoutes';
import { I18nextProvider } from 'react-i18next';
import { dates, resolver, theme } from '@/config/mantine';
import { Notifications } from '@mantine/notifications';
import store, { persistor } from './data/store';
import i18n from './services/i18n/i18n';
import Loading from './components/Loading';

const App = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => { i18n.on('initialized', () => setIsReady(true)); }, []);

  if (!isReady) {
    return (
      <MantineProvider theme={theme} cssVariablesResolver={resolver}>
        <Loading />
      </MantineProvider>
    );
  }

  return (
    <I18nextProvider i18n={i18n}>
      <MantineProvider theme={theme} cssVariablesResolver={resolver}>
        <Notifications position="bottom-right" />
        <DirectionProvider>
          <DatesProvider settings={dates}>
            <Provider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <RouterProvider router={router} />
              </PersistGate>
            </Provider>
          </DatesProvider>
        </DirectionProvider>
      </MantineProvider>
    </I18nextProvider>
  );
};

export default App;
